<template>
  <div :class="{ sentErp: value.sent_to_erp != 0 }" class="order-view">
    <div
      :class="{ active: expanded }"
      class="customer-header"
      @click="display()"
    >
      <span :class="{ expanded: expanded }" class="arrow_key">
        <i class="angle left icon"></i>
      </span>
      <div v-if="home" class="float-right">
        <button class="ui button small" @click="openCustomer()">Client</button>
      </div>
      <h4>
        {{ $t('Order') }}
        {{ value.reference }}
        <span class="id-order">({{ value.id }}) </span>
        <span class="order-price">{{ value.total_paid | price }}</span>
        <span>
          <a class="ui button small blue btn_customer" target="_blank" :href="prestashop_order_link(value.id)">
            {{ $t('View on Prestashop') }}
        </a>
        </span>
      </h4>
      <div>
        {{ $t('Customer') }}

        <b>{{ value.customer.firstname }} {{ value.customer.lastname }}</b>
      </div>
      <div>
        {{ $t('Address') }}

        <span class="bold" v-if="value.delivery_address">
          {{ value.delivery_address.address1 }} {{ value.delivery_address.address2 }} {{ value.delivery_address.postcode }} {{ value.delivery_address.city }}
        </span>
      </div>
      <div>
        {{ $t('Phone') }}

        <span class="bold" v-if="value.delivery_address">
          {{ value.delivery_address.phone_mobile }}
        </span>
      </div>
      <div>
        {{ $t('Order made on') }}
        <b>{{ value.date_add }}</b>
      </div>
    </div>
    <div v-if="expanded" class="customer-details">
      <div class="message">
        <div v-if="value.message != null" class="message-content">
          {{ value.message }}
        </div>
      </div>
      <table class="ui celled small very compact table center aligned">
        <thead>
          <tr>
            <th class="three wide productName">
              {{ $t('Name') }}
            </th>
            <th v-if="currentCustomer">
              {{ $t('Cart') }}
            </th>
            <th class="one wide">{{ $t('Reference') }}</th>
            <th class="one wide">{{ $t('Qty') }}</th>
            <th class="one wide">{{ $t('Price') }}</th>
            <th class="one wide">{{ $t('Group Reduction') }}</th>
            <th class="one wide">{{ $t('Total Price') }}</th>
            <th class="one wide">{{ $t('ERP Status') }}</th>
            <th class="one wide">{{ $t('ERP Ops') }}</th>
            <th class="one wide">{{ $t('Product status') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(product, idx) in value.products" :key="idx">
            <td>
              <p class="text-left" :inner-html.prop="product.product_name | formatProductName"></p>
            </td>
            <td v-if="currentCustomer">
              <span v-if="getQuantityInCart(product) > 0" style="color: green">
                {{ getQuantityInCart(product) }}
              </span>
              <div v-else>
                <button
                  v-if="
                    product.product_reference ||
                    product.product_name != 'Transport'
                  "
                  class="ui mini button blue add-button"
                  title="Add to cart"
                  @click="addToCart(product)"
                >
                  <i class="add icon"></i>
                </button>
              </div>
            </td>
            <td>
              <!-- cashflow customized shirt  -->
              <div v-if="product.customizable != 0">
                <table
                  class="ui celled small very compact table center aligned reference-table"
                >
                  <tbody>
                    <tr>
                      <td>reference</td>
                      <td>{{ product.product_reference }}</td>
                    </tr>
                    <tr>
                      <td>tissue</td>
                      <td>{{ getTissu(product) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else>
                <!-- formens order product  -->
                <table
                  v-if="product.fms_id_formens_order"
                  class="ui celled small very compact table center aligned reference-table"
                >
                  <tbody>
                    <tr>
                      <td>{{ $t('Factory reference') }}</td>
                      <td class="formens">
                        {{ product.fms_factory_reference }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t('Product type') }}</td>
                      <td class="formens">{{ product.fms_product_type }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t('Pattern base') }}</td>
                      <td class="formens">{{ product.fms_pattern_base }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t('Base size') }}</td>
                      <td class="formens">{{ product.fms_base_size }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t('Product') }}</td>
                      <td>
                        {{product.id_product}}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t('Combination') }}</td>
                      <td>
                        {{product.product_attribute_id}}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t('Original price') }}</td>
                      <td class="original-price">
                        {{ product.original_product_price | price }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t('Suggested price') }}</td>
                      <td class="formens">
                        {{ product.fms_suggested_price | price }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- prestashop product  -->
                <table
                  v-else
                  class="ui celled small very compact table left aligned attributes-table"
                >
                  <tbody>
                    <tr>
                      <td>{{ $t('Reference') }}</td>
                      <td>{{ product.reference || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t('Product') }}</td>
                      <td :class="product.source">
                        {{ product.id_product }}
                      </td>

                    </tr>
                    <tr>
                      <td>{{ $t('Combination') }}</td>
                      <td :class="product.source">
                        {{
                          product.id_combination ||
                          product.id_product_attribute ||
                          product.product_attribute_id
                        }}
                      </td>
                    </tr>
                    <tr
                      v-for="(attribute_name, idx) in Object.keys(
                        getOrderProductAttributeList(product)
                      )"
                      :key="idx"
                    >
                      <td>{{ attribute_name }}</td>
                      <td :class="product.source">
                        {{
                          getOrderProductAttributeList(product)[attribute_name]
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
            <td>{{ product.product_quantity }}</td>
            <td class="price">
              {{
                (product.fms_suggested_price
                  ? product.fms_suggested_price
                  : product.product_price) | price
              }}
            </td>
            <td class="group-reduction">
              {{
                parseFloat(product.group_reduction) > 0 &&
                product.id_product != 62988
                  ? `-${Math.round(product.group_reduction)}%`
                  : ''
              }}
            </td>
            <td class="total-price">
              {{ product.total_price | price }}
            </td>
            <td class="erp_status">
              <span
                v-if="product.erp_status"
                :class="product.erp_status.toLowerCase()"
                class="status"
                >{{ product.erp_status }}</span
              >
              <a
                v-if="product.fms_id_formens_order"
                :href="erp_link(product.fms_factory_reference)"
                target="_blank"
              >
                {{ product.fms_factory_reference }}
              </a>
            </td>
            <td class="erp_ops">
              <!-- <button class="ui button blue reorderButton" @click="showOrderModal(product.id_order_detail)">Order again</button> -->
              <erp-modal
                v-if="!product.fms_id_formens_order"
                ref="erpModal"
                :order="value"
                v-model="value.products[idx]"
              >
                <button
                  v-if="product.sent_to_erp == 0"
                  slot="activator"
                  class="ui mini compact button green"
                >
                  {{ $t('Send to ERP') }}
                </button>
                <button
                  v-if="product.sent_to_erp == 1"
                  slot="activator"
                  class="ui mini compact button yellow"
                >
                  {{ $t('Resend to ERP') }}
                </button>
              </erp-modal>
            </td>
            <td>
              <product-status-modal
                ref="productStatusModal"
                v-if="product.status !== 'Delivered'"
                :order="value"
                v-model="value.products[idx]"
              >
                <button class="ui button yellow" slot="activator">
                  {{ $t('Mark as delivered') }}
                </button>
              </product-status-modal>
              <button v-else class="ui button green" disabled slot="activator">
                {{ $t('Delivered') }}
              </button>
            </td>
          </tr>
          <tr v-if="value.total_discounts > 0" class="total-discounts">
            <td>
              {{ $t('Total Discounts') }}
            </td>
            <td v-if="currentCustomer"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>-{{ value.total_discounts | price }}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr v-if="value.total_paid >= 0" class="total-paid">
            <td>{{ $t('Total Paid') }}</td>
            <td v-if="currentCustomer"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{{ value.total_paid | price }}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <div class="sendBulk" v-if="!hasFormensProductInCurrentOrder">
          <button
            :disabled="loading == true"
            class="ui button green"
            @click="showModal = true"
          >
            {{ $t('Send all products to ERP') }}
          </button>
      </div>
    </div>
    <popup-modal
      :index="showModal"
      icon="checkmark"
      cancel_class="ui red basic cancel inverted button"
      confirm_class="ui green ok inverted button"
      text="Are you sure you want to send all products to the ERP ?"
      @delete="sendOrderToERP()"
      @cancel="showModal = null"
    ></popup-modal>
    <popup-modal
      :index="order_again"
      icon="checkmark"
      cancel_class="ui red basic cancel inverted button"
      confirm_class="ui green ok inverted button"
      text="Are you sure you want to order this shirt again ?"
      @cancel="order_again = null"
      @delete="orderSameShirt()"
    ></popup-modal>
  </div>
</template>

<style scoped>
.bold {
  font-weight: bold;
}

.order-view {
  box-shadow: 0 0 17px 0 #eee;
  border-left: 5px solid #ff6e18;
  border-radius: 5px;
}

.customer-header {
  padding: 10px;
  background: white;
  margin-top: 20px;
}

.customer-header h4 {
  display: inline;
}

.customer-header.active {
  border-bottom: none;
}

.customer-details {
  border-top: 1px solid #333;
  background: white;
  padding: 10px 5px;
}

.customer-details.active {
  border-top: none;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 1%;
}

.customer-details .table {
  margin-left: 0;
}

.text-left {
  text-align: left;
}

.message .message-content {
  background-color: #209cee;
  color: white;
  padding: 1% 2% 1% 2%;
  border-radius: 4px;
  font-weight: bold;
}

.float-right {
  float: right;
}

.arrow_key {
  float: right;
  font-size: 2em;
  opacity: 0.8;
  color: #333;
  -webkit-transition: -webkit-transform 0.3s ease-in-out;
  -ms-transition: -ms-transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out;
}

.arrow_key.expanded {
  transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
}

.sentErp {
  border-left: 5px solid #21ba45 !important;
}

.sendBulk {
  padding-bottom: 2%;
  text-align: center;
}

.original-price {
  color: blue;
}

.total-price {
  color: green;
}

.group-reduction {
  color: red;
}

.total-discounts {
  color: red;
}

.total-paid {
  color: green;
}

.id-order {
  color: blue;
}

.order-price {
  color: green;
}

.add-button {
  width: 24px;
  display: flex;
  justify-content: center;
}

.reference-table tr {
  height: 14px;
}

.reference-table td {
  white-space: nowrap;
}

span.status {
  color: rgba(0, 0, 0, 0.87);
  border-radius: 5px;
  width: 120px;
  font-weight: bold;
  text-align: center;
  display: inline-block;
}

.reorderButton {
  margin-bottom: 10%;
}

span.no_data {
  background-image: linear-gradient(90deg, green 0%, lightgray 0%);
}

span.cancel {
  background-image: linear-gradient(90deg, red 100%, lightgray 100%);
}

span.start {
  background-image: linear-gradient(90deg, green 5%, lightgray 5%);
}

span.print {
  background-image: linear-gradient(90deg, green 10%, lightgray 10%);
}

span.fabric_cut {
  background-image: linear-gradient(90deg, green 20%, lightgray 20%);
}

span.fabric_cut_wait {
  background-image: linear-gradient(90deg, orange 20%, lightgray 20%);
}

span.fabric_waiting {
  background-image: linear-gradient(90deg, orange 20%, lightgray 20%);
}

span.fabric_no_more {
  background-image: linear-gradient(90deg, red 20%, lightgray 20%);
}

span.office_out {
  background-image: linear-gradient(90deg, green 30%, lightgray 30%);
}

span.workshop_in {
  background-image: linear-gradient(90deg, green 35%, lightgray 35%);
}

span.pattern_cut {
  background-image: linear-gradient(90deg, green 40%, lightgray 40%);
}

span.pattern_modifok {
  background-image: linear-gradient(90deg, green 40%, lightgray 40%);
}

span.patter_ok {
  background-image: linear-gradient(90deg, green 45%, lightgray 45%);
}

span.pattern_prob {
  background-image: linear-gradient(90deg, orange 40%, lightgray 40%);
}

span.workshop_out {
  background-image: linear-gradient(90deg, green 50%, lightgray 50%);
}

span.initials {
  background-image: linear-gradient(90deg, green 60%, lightgray 60%);
}

span.quality_ok {
  background-image: linear-gradient(90deg, green 70%, lightgray 70%);
}

span.tagged {
  background-image: linear-gradient(90deg, green 75%, lightgray 75%);
}

span.packaged {
  background-image: linear-gradient(90deg, green 80%, lightgray 80%);
}

span.ready_for_shipping {
  background-image: linear-gradient(90deg, green 90%, lightgray 90%);
}

span.delivered {
  background-image: linear-gradient(90deg, green 100%, lightgray 100%);
}

.formens {
  color: #e61a8d;
}

@media (max-width: 1200px) {
  .productName {
    min-width: 25vw;
  }
}

</style>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'OrderView',
  props: {
    value: {
      type: Object,
      default: null
    },
    active: {
      type: Boolean,
      default: true
    },
    home: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: null,
      order_again: null,
      loading: false,
      expanded: false,
      orderProductAttributeList: {}
    }
  },
  computed: {
    ...mapGetters({
      currentCustomer: 'getCurrentCustomer',
      groups: 'getGroups',
      products: 'getCartProducts'
    }),
    hasFormensProductInCurrentOrder() {
      if(!this.value.products) {
        return false
      }

      return this.value.products.some((product) => product.fms_id_formens_order)
    }
  },
  watch: {
    active(val) {
      this.expanded = val
    },
  },
  mounted() {
    this.expanded = this.active
  },

  methods: {
    display() {
      this.expanded = !this.expanded
      this.$emit('click')
    },
    openCustomer() {
      const customerId = this.value.id_customer

      // Retrieve the customer details.
      axios.post(`/customers`, {id: customerId}).then((customerResponse) => {
        const customer = customerResponse.data.customers[0];

        // Retrieve the customer's orders.
        axios.get(`/customer/${customer.id}/orders`).then((response) => {
          customer.orders = response.data.orders
          this.$store.dispatch('addCustomer', customer)
          this.$router.push({ name: 'CustomerView' })
        })
      })
    },
    sendOrderToERP() {
      this.showModal = null
      this.loading = true
      axios
        .post('/erp/order', { id_order: this.value.id_order })
        .then((response) => {
          // eslint-disable-next-line
          console.log(response)
          this.$awn.success('Order successfully updated.')
          this.loading = false
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.loading = false
        })
    },
    showERPModal(orderIndex, productIndex) {
      this.erp_product = this.pendingOrders[orderIndex].products[productIndex]
      this.$refs.erpModal.open()
    },
    getTissu(product) {
      let tissu = ''
      this.groups.forEach((group) => {
        group.parameters.forEach((parameter) => {
          if (parameter.ps_attribute_name === 'TISSU') {
            const idTissu = parseInt(product.id_tissu, 10) + 1000000
            parameter.values.forEach((value) => {
              if (value.id_value === idTissu) {
                tissu = value.display_name
              }
            })
          }
        })
      })
      return tissu
    },
    getOrderProductAttributeList(product) {
      const combination = product.combinations[product.product_attribute_id] || {}
      return combination.attribute_list || {}
    },
    getQuantityInCart(product) {
        let quantity = 0;
        this.products.forEach((cartProduct) => {
          if(
            // Part of the same order
            cartProduct.id_order === product.id_order &&

            // Part of the same product
            cartProduct.id_product === product.id_product &&

            // Same product attribute or combination
            (cartProduct.product_attribute_id === product.product_attribute_id || cartProduct.id_combination === product.id_combination)
          ) {
            quantity += 1;
          }
        });

        return quantity;
    },
    addToCart(product) {
      const newProduct = {
        ...product,
        source: 'order',
        customizable: true,
        isShirt: this.isProductShirt(product),
        // price: product.product_price * 1.196,
        price: product.unit_price_tax_incl,
        id_combination: product.product_attribute_id || null
      }

      // Removing unwanted information on the product
      // delete newProduct.id_product
      delete newProduct.id_order

      newProduct.customizable = newProduct.isShirt;

      this.$store.dispatch('addFromExistingProduct', newProduct);
    },
    erp_link(facRef) {
      return `https://b2b2.formens.ro/mtmonline/vieworder/orderNo/${facRef}`
    },
    prestashop_order_link(orderId) {
      return `https://www.cottonsociety.com/admin079eg25ilxe9bpr9l37/index.php?controller=AdminOrders&vieworder&id_order=${orderId}`
    },
    isProductShirt(product) {
      if(!Object.hasOwn(product, 'options'))
        return false;

      const excluded = ["TISSU", "COLOR", "TEXTINITIAL"];

      return Object.values(product.options)
        .flatMap(obj => Object.entries(obj))
        .filter(([key]) => !excluded.includes(key))
        .every(([, value]) => value !== null && value !== undefined && value !== "");
    }
  }
}
</script>



// WEBPACK FOOTER //
// OrderView.vue?5730496c